<script setup>
import InstagramPost from './layouts/InstagramPost.vue';
import TwitterPost from './layouts/TwitterPost.vue';
import FacebookPost from './layouts/FacebookPost.vue';

const props = defineProps({
  postLink: {
    type: String,
    default: null,
  },
});

const layoutType = computed(() => {
  if (props.postLink.includes('instagram.com')) {
    return InstagramPost;
  }

  if (props.postLink.includes('twitter.com') || props.postLink.includes('x.com')) {
    return TwitterPost;
  }

  if (props.postLink.includes('facebook.com')) {
    return FacebookPost;
  }

  return false;
});
</script>

<template>
  <component :is="layoutType" v-if="layoutType" v-bind="{ postLink: props.postLink }" />
</template>
